import React, { useMemo, useState, useCallback } from 'react';
import { StyleSheet, Pressable, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';

const createStyles = (colors, size) => StyleSheet.create({
  tabContainer: {
    flexDirection: 'row',
    backgroundColor: colors.solid_color_tertiary,
    borderRadius: 8,
    padding: 4,
  },
  tabButton: {
    flex: 1,
    paddingHorizontal: 12,
    paddingVertical: size === 's' ? 6 : size === 'n' ? 10 : 12,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tabButtonActive: {
    backgroundColor: colors.solid_color_primary,
  },
  tabButtonHovered: {
    backgroundColor: colors.solid_color_secondary,
  },
  tabIcon: {
    marginRight: 6,
  },
});

const TabButton = React.memo(({ tab, index, size, colors, styles }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Pressable 
      key={`tab-${index}`}
      style={[
        styles.tabButton,
        tab.active && styles.tabButtonActive,
        !tab.active && hovered && styles.tabButtonHovered,
      ]}
      onPress={tab.onPress}
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
    >
      {tab.icon && (
        <Icon 
          name={tab.icon} 
          size={16} 
          color={tab.active ? colors.text_color_primary : colors.text_color_secondary}
          style={styles.tabIcon}
        />
      )}
      <Text 
        size={size}
        color={tab.active ? 'primary' : 'secondary'}
      >
        {tab.label}
      </Text>
    </Pressable>
  );
});

const Tabs = ({ tabs, size = 'n' }) => {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors, size), [colors, size]);

  return (
    <View style={styles.tabContainer}>
      {
        Array.isArray(tabs) && tabs.map((tab, index) => (
          <TabButton key={`tab-${index}`} tab={tab} index={index} size={size} colors={colors} styles={styles} />
        ))
      }
    </View>
  );
};

export default React.memo(Tabs);